"use strict";

(function () {
  const COOKIE_NAME = 'kvik_cc';
  const COOKIE_PROPERTY_JS = '_js';
  const DATA_JS = 'data-js';
  const DATA_COOKIE_CONSENTS_UPDATE_URL = 'data-cookie-consents-update-url';
  const VISIBLE_CLASS_NAME = '--visible';
  const SWITCHER_LABEL_CLASS_NAME = 'cookieConsent__sectionConsent__switcherLabel__text';
  const DATA_COOKIE_CONSENTS_DURATION_SECONDS = 'data-cookie-consents-duration-seconds';
  const DATA_COOKIE_CONSENT_CODENAMES = 'data-cookie-consent-codenames';
  const DATA_INIT = 'data-init';
  window.km_cookieConsentInit = function () {
    const form = document.getElementById('cookieConsent__form');
    if (!form || form.hasAttribute(DATA_INIT)) {
      return;
    }
    const buttonSelection = document.getElementById('cookieConsent__buttonSelection');
    const buttonGrantSelection = document.getElementById('cookieConsent__buttonGrantSelection');
    const buttonGrantNone = document.getElementById('cookieConsent__buttonGrantNone');
    const buttonGrantAll = document.getElementById('cookieConsent__buttonGrantAll');
    const sectionStorageConsent = document.getElementById('cookieConsent__sectionStorageConsent');
    const sectionSelection = document.getElementById('cookieConsent__sectionSelection');
    const consentCheckboxes = getCookieConsentCheckboxes(form);
    buttonSelection.addEventListener('click', event => {
      event.preventDefault();
      buttonGrantSelection.removeAttribute('hidden');
      sectionSelection.removeAttribute('hidden');
      buttonSelection.setAttribute('hidden', null);
      sectionStorageConsent.setAttribute('hidden', null);
      if (buttonGrantNone) {
        buttonGrantNone.setAttribute('hidden', null);
      }
    });
    if (buttonGrantNone) {
      buttonGrantNone.addEventListener('click', function () {
        for (const key in consentCheckboxes) {
          if (!consentCheckboxes[key].disabled) {
            consentCheckboxes[key].checked = false;
          }
        }
      });
    }
    buttonGrantAll.addEventListener('click', function () {
      for (const key in consentCheckboxes) {
        consentCheckboxes[key].checked = true;
      }
    });
    for (const key in consentCheckboxes) {
      consentCheckboxes[key].onchange = function () {
        for (const label of consentCheckboxes[key].parentElement.getElementsByClassName(SWITCHER_LABEL_CLASS_NAME)) {
          if (label.classList.contains(VISIBLE_CLASS_NAME)) {
            label.classList.remove(VISIBLE_CLASS_NAME);
          } else {
            label.classList.add(VISIBLE_CLASS_NAME);
          }
        }
      };
    }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const consentData = getConsentDataFromCheckboxes(consentCheckboxes);

      // If cookie was already persisted before, send the form.
      // It solves the case when a cookie is httpOnly and cannot be change in JS.
      if (form.getAttribute(DATA_JS) !== 'true') {
        fetch(form.getAttribute(DATA_COOKIE_CONSENTS_UPDATE_URL), {
          method: 'POST',
          body: JSON.stringify(consentData),
          credentials: 'same-origin',
          // To send cookies.
          redirect: 'follow',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            // Because of Nette's isAjax()
            'Content-Type': 'application/json'
          }
        }).catch(response => {
          console.info(response);
        }).catch(err => {
          console.error(err);
        });
      }
      const currentTimestamp = new Date().getTime();
      const durationTimestamp = parseInt(form.getAttribute(DATA_COOKIE_CONSENTS_DURATION_SECONDS)) * 1000;
      const expirationDate = form.hasAttribute(DATA_COOKIE_CONSENTS_DURATION_SECONDS) ? new Date(currentTimestamp + durationTimestamp) : null;
      if (setCookieConsentsCookie(consentCheckboxes, expirationDate)) {
        gtag('consent', 'update', consentData);
        window.dataLayer.push({
          consent: consentData
        });
        window.kvik_modal.destroy(true);
      }
    });
    form.setAttribute(DATA_INIT, 1);
  };
  onDOMReady(function () {
    window.km_cookieConsentInit();
  });

  /**
   * @param {HTMLFormElement} form
   */
  function getCookieConsentCheckboxes(form) {
    const elements = form.elements;
    const result = {};
    for (let i = 0; i < elements.length; i++) {
      let item = elements.item(i);
      const found = item.name.match(/cookieConsents\[([a-z]+)\]/i);
      if (found) {
        result[found[1]] = item;
      }
    }
    return result;
  }
  function setCookieConsentsCookie(consentCheckboxes, expirationDate) {
    const cookieConsentsObject = {};
    for (const key in consentCheckboxes) {
      cookieConsentsObject[key] = consentCheckboxes[key].checked;
    }
    cookieConsentsObject[COOKIE_PROPERTY_JS] = Number(new Date());
    const base64Value = btoa(JSON.stringify(cookieConsentsObject));
    document.cookie = `${COOKIE_NAME}=${base64Value};path=/;${expirationDate ? `expires=${expirationDate.toUTCString()};` : ``}`;

    // Confirm that cookie was set properly. It means that httpOnly cookie (non-overwrittable) did not exist before.
    return document.cookie.indexOf(COOKIE_NAME) !== -1;
  }
  function getConsentDataFromCheckboxes(consentCheckboxes) {
    const consent = {};
    for (const key in consentCheckboxes) {
      // noinspection JSUnfilteredForInLoop
      const inputElement = consentCheckboxes[key];
      const value = inputElement.checked ? 'granted' : 'denied';
      const codenames = JSON.parse(inputElement.getAttribute(DATA_COOKIE_CONSENT_CODENAMES));
      for (const i in codenames) {
        const snakeCaseKey = codenames[i].replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        consent[snakeCaseKey] = value;
      }
    }
    return consent;
  }
})();